module.exports = __webpack_public_path__ + "img/banner@2x.394b0288.jpg";